import { render, staticRenderFns } from "./district-admins.vue?vue&type=template&id=73a7c3e6&scoped=true"
import script from "./district-admins.vue?vue&type=script&lang=js"
export * from "./district-admins.vue?vue&type=script&lang=js"
import style0 from "./district-admins.vue?vue&type=style&index=0&id=73a7c3e6&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73a7c3e6",
  null
  
)

export default component.exports